/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {onboardSquareMerchant} from '../api'

export const useMutationOnboardSquareMerchant = createReactQueryMutationHook('onboardSquareMerchant', onboardSquareMerchant)
